import { render, staticRenderFns } from "./EditMonthlyPlan.vue?vue&type=template&id=23a641c0&"
import script from "./EditMonthlyPlan.vue?vue&type=script&lang=js&"
export * from "./EditMonthlyPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports